import { computed, reactive } from 'vue';

interface State<T> {
    loading: boolean;
    items: T[];
    empty: boolean;
}

export function useSimpleList<T>({ list, loading = true }: { list: () => Promise<T[]>, loading?: boolean }) {
    const state: State<T> = reactive({
        loading,
        items: [],
        empty: computed(() => !state.items.length),
    });

    async function fetch() {
        state.loading = true;

        try {
            state.items = await list();
        } finally {
            state.loading = false;
        }
    }

    return { state, fetch };
}
